<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import Table from "@/components/standard/Induction/components/InductionTable";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import InductionAPI from "@/services/standards/inductionProgram/inductionProgramAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import newScoresAPI from "../../../services/newScores/newScoresAPI"

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "1.2.2 Capacitación, Inducción y Reinducción en SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
  },
  data() {
    return {
      title: "1.2.2 Capacitación, Inducción y Reinducción en SG SST",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "1.2.2 Listado de Capacitación, Inducción y Reinducción en SG SST",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id}/induccion`,
        },
        {
          text: " Editar Capacitación",
          active: true,
        },
      ],
      list: [],
      trainingList: [],

      program: {
        induction_date: null,
        induction_final_date: null,
        induction_theme: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
        observations: null,
        evidence: null,
      },
      file: null,
      submitted: false,
      company: null,
      companyNit: this.$store.getters["company/getCompany"].nit,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading1: true,
      loading2: true,
      loading3: true,
      inductionID: this.$route.params.induction,
      item: null,
      itemStatus: null,
      itemData: null,
    };
  },
  validations: {
    program: {
      induction_date: {
        required,
      },
      induction_final_date: {
        required,
      },
      induction_theme: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(10)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.program.evidence)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.companyNit}/1.1.2/${this.inductionID}/${name}`;
        } else {
          url = `sst-prod/${this.companyNit}/1.1.2/${this.inductionID}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.program.evidence = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getTrainingPrograms() {
      InductionAPI.getTema(this.companyID)
        .then((response) => {
          this.loading = false;
          this.trainingList = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    async save() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.loading1 = true;
        const res = await this.uploadDocument();
        if (res) {
          const data = {
            induction_date: this.program.induction_date,
            induction_final_date: this.program.induction_final_date,
            induction_theme: this.program.induction_theme,
            companies_id: this.program.companies_id,
            observations: this.program.observations,
            evidence: this.program.evidence,
          };
          InductionAPI.update(this.inductionID, data)
            .then((response) => {
              if (response.Success === "updated Successfull") {
                const itemChange = {
                  companies_id: this.companyID,
                  item_id: 10,
                  status: 'Pendiente',
                };
                newScoresAPI.calculateScores(itemChange)
                  .then((response) => {
                    this.loading1 = false,
                      setTimeout(() => {
                        Swal.fire({
                          title: "¡success!",
                          text: "¡Se ha actualizado con éxito!",
                          icon: "success",
                          confirmButtonClass: "btn btn-confirm mt-2",
                        });
                      }, 3000);
                    this.goBack();
                  })
                  .catch((error) => {
                    this.loading1 = false
                    setTimeout(() => {
                      Swal.fire({
                        title: "Error",
                        text: "¡No se ha podido actualizar!",
                        icon: "error",
                        type: "error",
                        confirmButtonClass: "btn btn-confirm mt-2",
                      });
                      window.location.reload();
                    }, 1000);
                    console.log(error);
                  });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log("error");
        }
      }
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 10)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getData() {
      CompanyAPI.getCompany(this.companyID)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });

      InductionAPI.get(this.inductionID)
        .then((response) => {
          this.program.induction_date = response.induction_date,
            this.program.induction_final_date = response.induction_final_date,
            this.program.induction_theme = response.induction_theme,
            this.program.companies_id = response.companies_id,
            this.program.observations = response.observations,
            this.program.evidence = response.evidence,
            this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.getData();
    this.getItems();
    this.getItemData();
    this.getTrainingPrograms();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12">
                  <b-form-group class="col-md-6 px-2" label="Fecha inicio de capacitación" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Editar')" type="date" id="trainingDate"
                      v-model="program.induction_date"
                      :class="{ 'is-invalid': $v.program.induction_date.$error && submitted }">
                      >
                    </b-form-input>
                    <div v-if="submitted && $v.program.induction_date.$error">
                      <small v-if="!$v.program.induction_date.required" class="text-danger">
                        <b>La fecha de la capacitación es requerida</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Fecha fin de capacitación" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Editar')" type="date" id="trainingDate"
                      v-model="program.induction_final_date"
                      :class="{ 'is-invalid': $v.program.induction_final_date.$error && submitted }">
                      >
                    </b-form-input>
                    <div v-if="submitted && $v.program.induction_final_date.$error">
                      <small v-if="!$v.program.induction_final_date.required" class="text-danger">
                        <b>La fecha de la capacitación es requerida</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Tema de capacitación" label-for="theme">
                    <b-form-select :disabled="!allowAccess() || !getRole('Crear')" required id="theme"
                      v-model="program.induction_theme">
                      <b-form-select-option v-for="(item, index) in trainingList" :key="index"
                        :value="item.training_done">
                        {{ item.training_done }}

                      </b-form-select-option>
                    </b-form-select>

                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Evidencia de capacitación" label-for="evidence">
                    <b-form-file :disabled="!allowAccess() || !getRole('Editar')" id="evidence" ref="evidence"
                      name="evidence" browse-text="Buscar"
                      :placeholder="program.evidence ? getFile(program.evidence) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      v-on:change="uploadFile">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Editar')" id="description"
                      v-model="program.observations">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="!allowAccess() || !getRole('Editar')" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="button" @click="goBack" class="btn btn-secondary mx-1">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
          <!-- end card -->
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
